var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    staticClass: "px-0",
    attrs: {
      "stitch": "",
      "help-content-id": "popup-addcontractline-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$translate("title")))]), _c('template', {
    slot: "rawcontent"
  }, [_c('div', {
    staticClass: "add-to-catalog-modal"
  }, [_vm.stats.products ? [_vm.step === 'select' ? [_c('div', {
    staticClass: "px-4 pt-3"
  }, [_c('Info', {
    attrs: {
      "elevation": 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("importProductsDescription")) + " ")])], 1), _c('tabs', {
    staticClass: "add-to-catalog-modal__tabs",
    attrs: {
      "value": _vm.tab,
      "tabs": _vm.tabs
    },
    on: {
      "change": function change($event) {
        return _vm.changeTab($event);
      }
    }
  }, [_c('template', {
    slot: "tabs"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('v-tab-item', {
      key: tab.name,
      staticClass: "py-2"
    }, [tab.name == 'products' ? _c('Products') : tab.name == 'selected' ? _c('SelectedItems') : _vm._e()], 1);
  }), 1)], 2)] : _vm.step === 'piece_content' ? [_c('div', {
    staticClass: "px-4 pt-4 pb-2"
  }, [_c('div', {
    staticClass: "d-flex align-center flex-wrap mb-2"
  }, [_c('v-btn', {
    staticClass: "px-0 mr-3",
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.backToSelection
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.$translate("backToSelection")) + " ")], 1), _c('v-chip', {
    staticClass: "font-weight-medium",
    attrs: {
      "small": "",
      "label": "",
      "color": "primary",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("stepPieceContent")) + " ")])], 1)]), _c('div', {
    staticClass: "px-4 pb-4"
  }, [_c('PieceContentStep')], 1)] : _vm._e()] : [_c('Placeholder', {
    staticClass: "pa-4",
    attrs: {
      "icon": "product",
      "title": _vm.$translate('noProducts'),
      "description": _vm.$translate('noProductsDescription')
    }
  })]], 2)]), _c('template', {
    slot: "bottom"
  }, [_vm.stats.products ? [_c('v-btn', {
    staticClass: "my-2 my-sm-3 w-100 w-sm-auto",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("cancel")) + " ")]), _vm.step === 'select' ? _c('v-btn', {
    staticClass: "my-2 my-sm-3 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "disabled": _vm.isBusy,
      "loading": _vm.adding_products,
      "color": "primary"
    },
    on: {
      "click": _vm.continueClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.continue_text) + " ")]) : _vm.step === 'piece_content' ? _c('v-btn', {
    staticClass: "my-2 my-sm-3 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "disabled": _vm.isBusy,
      "loading": _vm.saving_piece_content || _vm.adding_products,
      "color": "primary"
    },
    on: {
      "click": _vm.saveAndAddClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.saveAndAdd_text) + " ")]) : _vm._e()] : [_c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("close")) + " ")])]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }